import emma from '../services/Emma'

const DjangoResource = {
	getUserPerformance (clientId = '') {
		return emma.get(`api/get-user-performance/${clientId}`).then((resp) => {
			return JSON.parse(resp.data)
		})
	}
}

export default DjangoResource



// WEBPACK FOOTER //
// ./src/common/resources/Django.js